import React from 'react';
import styles from './CounterpartiesCounterView.module.scss';
import {Image} from '../../../../../../../../../components';
import magnifier from 'assets/images/svg/magnifier.svg';

interface CounterpartiesCounterViewProps {
  availableCount?: number;
  isLoading?: boolean;
}

const CounterpartiesCounterView = ({
  availableCount,
  isLoading = false
}: CounterpartiesCounterViewProps) => {
  const displayValue =
    isLoading ? null : (typeof availableCount === 'number' ? availableCount : null);

  return (
    <div className={styles.counterView}>
      <div className={styles.bonusHeader}>
        <Image src={magnifier} className={styles.bonusIcon} alt="" aria-hidden />
        <div className={styles.bonusText}>
          <p className={styles.bonusTitle}>Бонус от компании Rescore*</p>
          <p className={styles.bonusSubtitle}>* входит в группу компаний Conomica</p>
        </div>
      </div>
      <p className={styles.counterIntro}>Вам доступно</p>
      <p
        className={styles.counterValue}
        aria-label={
          displayValue !== null
            ? `${displayValue} бесплатных проверок`
            : isLoading
              ? 'Загрузка'
              : undefined
        }
        aria-busy={isLoading}
      >
        {displayValue !== null ? displayValue : isLoading ? '…' : '—'}
      </p>
      <p className={styles.counterDescription}>
        бесплатных проверок Ваших контрагентов
      </p>
    </div>
  );
};

export default CounterpartiesCounterView;
